import { render } from "./StreamsManagePaywall.vue?vue&type=template&id=5320361e"
import script from "./StreamsManagePaywall.vue?vue&type=script&lang=js"
export * from "./StreamsManagePaywall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManagePaywall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5320361e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5320361e', __exports__)) {
    api.reload('5320361e', __exports__)
  }
  
  module.hot.accept("./StreamsManagePaywall.vue?vue&type=template&id=5320361e", () => {
    api.rerender('5320361e', render)
  })

}


export default __exports__